module.exports = __webpack_public_path__ + "static/media/shvl_logo.d51d419d.png";